
import { Component, Vue } from 'vue-property-decorator'
import { 
    SupplementPersonInfo,
    // EducationListDto,
    // MarriageListDto
 } from '@/api/iousServices'
import { Getter } from 'vuex-class'

@Component({
    name: 'SupplementInfo',
    components: {}
})
export default class supplementInfo extends Vue {
    @Getter companyId!: string
    labelWidth = '7em'
    showCalendar1 = false // 签约开始时间选择空间显示控制
    showCalendar2 = false // 签约结束时间选择空间显示控制
    formData: SupplementPersonInfo = {
        currentAddress: '',
        emergencyName: '',
        emergencyPhone: '',
        emergencyName1: '',
        emergencyPhone1: '',
        educationList: [],
        marriageList: []
    }
    // educationList: EducationListDto[] = []
    // marriageList: MarriageListDto[] = []

    created () {
        this.$nextTick(() => {
        })
    }

    // input输入限制（英文、数字）独立编码
    formatterInput (value) {
        return value.replace(/[^a-zA-Z\d]/g, '')// 英文和数字
    }

    addSure () {
        (this.$refs.addInfo as any).validate().then(() => {
        })
    }
}
